/* eslint-disable
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const { gql } = require('@apollo/client');

const deps = ['Collection', 'GatewayApi', 'Conversation'];
const factory = function (Collection, GatewayApi, Conversation) {
  let ConversationCollection;
  return (ConversationCollection = (function () {
    ConversationCollection = class ConversationCollection extends Collection {
      static initClass() {
        this.prototype.id = null;
        this.prototype.$apiService = GatewayApi;
        this.prototype.$type = Conversation;
      }

      $url() {
        return `clients/${this.clientId}/conversations/${this.attachedTo}`;
      }
      $init() {}

      $$transformGQLResponse(response) {
        const r = [...response];
        return r.map(item => ({
          ...item,
          comments: item.comments.data,
        }));
      }

      $fetch(options = { reset: false }) {
        const query = gql`
          query Conversation($clientId: ID!, $attachedToId: ID!) {
            client(id: $clientId) {
              id
              conversations(attachedToId: $attachedToId) {
                id
                attachedTo
                comments {
                  data {
                    authorId
                    authorName
                    authorEmail
                    date
                    body
                    editAuthorId
                    editAuthorName
                    editAuthorEmail
                    edited
                  }
                }
              }
            }
          }
        `;

        const variables = { clientId: this.clientId, attachedToId: this.attachedTo };
        return this.$graphqlClient.query({ query, variables }).then(res => {
          if (res.data.client.conversations.length > 0) {
            this.$set(this.$$transformGQLResponse(res.data.client.conversations), {
              reset: options.reset,
            });
          }
          return this.$cache();
        });
      }

      $post(comment) {
        const mutation = gql`
          mutation createConversation($attachedToId: ID!, $clientId: ID!, $commentBody: String!) {
            createConversation(
              attachedToId: $attachedToId
              clientId: $clientId
              commentBody: $commentBody
            ) {
              id
              attachedTo
              comments {
                data {
                  authorId
                  authorName
                  authorEmail
                  date
                  body
                  editAuthorId
                  editAuthorName
                  editAuthorEmail
                  edited
                }
              }
            }
          }
        `;

        const variables = {
          attachedToId: this.attachedTo,
          clientId: this.clientId,
          commentBody: comment,
        };
        return this.$graphqlClient.mutate({ mutation, variables }).then(res => {
          this.$fetch();
          return res;
        });
      }
    };
    ConversationCollection.initClass();
    return ConversationCollection;
  })());
};

factory.$inject = deps;

module.exports = angular
  .module('bench.data.collection.conversations', [
    require('data/model/conversation').name,
    require('data/util').name,
  ])
  .factory('ConversationCollection', factory);
